interface RfqLiquidityDistributionFields {
  liquidityDistributionCex?: number | null
  liquidityDistributionDex?: number | null
}

/**
 * There is no persisted form-version marker on `market_maker_rfqs`, so we infer it:
 * the rfq-v2 form always collects the liquidity distribution split (must sum to 100),
 * while the legacy form never submits it. RFQs created via the v2 form skip several
 * legacy questions (specialists, motivations, beliefs, financial/legal background) and
 * store hard-coded defaults for them, so those answers must not be shown to market makers.
 */
export function isRfqV2Form(rfq: RfqLiquidityDistributionFields | null | undefined): boolean {
  return rfq?.liquidityDistributionCex != null && rfq?.liquidityDistributionDex != null
}

export function formatLiquidityDistribution(rfq: RfqLiquidityDistributionFields | null | undefined): string | undefined {
  if (rfq?.liquidityDistributionCex == null || rfq?.liquidityDistributionDex == null) {
    return undefined
  }
  return `${rfq.liquidityDistributionCex}% CEX / ${rfq.liquidityDistributionDex}% DEX`
}
